import { useEffect, useState } from "react";

const images = [
  {
    img: "/banner/candle banner  (9).png",
    mobileImg: "/banner/22.png",
    link: "/FindYourState",
  },
  {
    img: "/banner/candle banner  (11).png",
    mobileImg: "/banner/23.png",
    link: "/signature",
  },
  // {
  //   img: "/banner/banner3.png",
  //   mobileImg: "/banner/mobile-banner3.jpeg",
  //   link: "/signature",
  // },
];
const sliderImages = [
  ...images,
  images[0]
];
function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [direction, setDirection] = useState("next");
  const [disableTransition, setDisableTransition] = useState(false);
const handleTouchStart = (e) => {
  setTouchStart(e.targetTouches[0].clientX);
};

const handleTouchMove = (e) => {
  setTouchEnd(e.targetTouches[0].clientX);
};

const handleTouchEnd = () => {
  if (!touchStart || !touchEnd) return;

  const distance = touchStart - touchEnd;

  if(distance > 50){
    setCurrentIndex(prev => prev + 1);
  }

  if(distance < -50){
    setCurrentIndex(prev =>
      prev === 0 
      ? sliderImages.length - 1 
      : prev - 1
    );
  }

  setTouchStart(null);
  setTouchEnd(null);
};
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    const interval = setInterval(() => {
  setCurrentIndex((prev) => prev + 1);
}, 5500);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", checkMobile);
    };
  }, []);
useEffect(() => {
  if (currentIndex === sliderImages.length - 1) {

    setTimeout(() => {

      setDisableTransition(true);
      setCurrentIndex(0);

      setTimeout(() => {
        setDisableTransition(false);
      }, 50);

    }, 800);

  }
}, [currentIndex]);
  return (
    <>
      <style>{`
    .hero {
width: 80%;
position: relative;
overflow: hidden;
margin: 0 auto;
margin-top: 80px;
}

.slider-container {
  display:flex;
  width:100%;
  height:100%;
  transition:transform .8s cubic-bezier(.77,0,.18,1);
}

.slide {
  min-width:100%;
  height:100%;
  position:relative;
}

.slide img {
  width:100%;
  object-fit:contain;
  display:block;
  margin-top:60px
}


.dots {
  position:absolute;
  bottom:25px;
  left:50%;
  transform:translateX(-50%);
  display:flex;
  gap:10px;
  z-index:5;
}

.dot {
  width:8px;
  height:8px;
  border-radius:50%;
  background:#ffffff80;
}

.dot.active {
  width:25px;
  border-radius:20px;
  background:#fff;
}


@media(max-width:768px){

.hero{
 height:90%;
 aspect-ratio:9/16;
 margin-top:60px;
 width:90%;
}

.slide img{
 object-fit:cover;
 margin-top:40px;
}

}
@media(max-width:768px){

.hero{
  height:90%;
  aspect-ratio:9/16;
  margin-top:60px;
  width:90%;
}

.slide img{
  object-fit:cover;
  margin-top:40px;
}

/* Right side dots */


}
@media (max-width: 768px) {

  .dots {
    position: absolute;
    left: 20px;
    bottom: 20px;

    top: auto;
    right: auto;

    transform: none;

    display: flex;
    flex-direction: row;
    gap: 8px;

    z-index: 5;
  }

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ffffff80;
  }

  .dot.active {
    width: 25px;
    height: 8px;
    border-radius: 20px;
    background: #fff;
  }
}
      `}</style>

      <section
 className="hero"
 onTouchStart={handleTouchStart}
 onTouchMove={handleTouchMove}
 onTouchEnd={handleTouchEnd}
>

<div
 className="slider-container"
 style={{
   transform:`translateX(-${currentIndex * 100}%)`,
   transition: disableTransition 
     ? "none" 
     : "transform .8s cubic-bezier(.77,0,.18,1)"
 }}
>

{sliderImages.map((item,index)=>{
const bannerImg = isMobile 
 ? item.mobileImg 
 : item.img;

return(
<div
 className="slide"
 key={index}
 onClick={()=>{
   window.location.href=item.link;
 }}
>

<img 
src={bannerImg}
alt={`Banner ${index+1}`}
/>

</div>
)

})}

</div>


 <div className="dots">

{images.map((_,index)=>(

<span
key={index}
className={`dot ${
(currentIndex % images.length)===index ? "active":""}`}
onClick={(e)=>{
e.stopPropagation();
setCurrentIndex(index);
}}
></span>

))}

</div> 

</section>
    </>
  );
}

export default Hero;